import { Button } from "react-bootstrap";
import NoContent from "../components/common/NoContent";
import { TREND } from "../constants";
import { Organization } from "../models/Organization";
import { format, parseISO } from "date-fns";
import { isEmpty } from "lodash";

export function renderValue(val) {
	return <div>{val}</div>
}

export function renderPeriod(organization?:Organization) {
	if(organization) {
		var viewWindow = ""

		if (organization?.startViewableWindow) {
			viewWindow = format(parseISO(organization?.startViewableWindow.toString()), 'MMM do')
		}

		if (organization?.endViewableWindow) {
			viewWindow = `${viewWindow} - ${format(parseISO(organization?.endViewableWindow.toString()), 'MMM do')}`
		}

		return (
			<div className="row" >
				<div className="col-12 align-items-center">
					<div className="card" style={{padding: "0.35rem"}}>
						<div className="card-body align-items-center" style={{padding: "0.35rem", color:'white'}}>
							<div className="text-center fw-bold">
								<div style={{color:'white', height:20}}>
									<div className="fw-bold">{viewWindow}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		) 
	}	
}

export function displayAcknowledgeDate(date?: Date|string) {
	const dateFormat = "MMMM dd, yyyy"
	const timeFormat = "hh:mm a"
	if (date) {
		if (date instanceof Date) {
			return `${format(date, dateFormat)} at ${format(date, timeFormat)}`
		} else {
			const realDate = parseISO(date.toString())
			return `${format(realDate, dateFormat)} at ${format(realDate, timeFormat)}`
		}
	} else {
		return undefined
	}
}

export function displayDate(date?: Date|string) {
	const dateFormat = "MM/dd/yy"
	if (date) {
		if (date instanceof Date) {
			return `${format(date, dateFormat)}`
		} else {
			const realDate = parseISO(date.toString())
			return `${format(realDate, dateFormat)}`
		}
	} else {
		return undefined
	}
}

export function getTrendClass(trend?:string, modifer?:string) {
	
	var trendClass = `fa-solid fa-arrows-h ${modifer} icn-orange mt-0`
	switch (trend) {
		case TREND.DOWN:
			trendClass = `fa-solid fa-arrow-down ${modifer} icn-red mt-0`
			break;
		case TREND.UP:
			trendClass = `fa-solid fa-arrow-up ${modifer} icn-green mt-0`
			break;
		case TREND.NO_CHANGE:
			trendClass = `fa-solid fa-arrows-h ${modifer} icn-orange mt-0`
			break;
		case TREND.NOT_APPLICABLE:
			trendClass = ``
			break;
		default:
			break;
	}

	return trendClass
}

export const NoContentWrapper = ({items, message, showIcon, ...props}) =>{
	if (isEmpty(items)) {
		return <NoContent message={message} showIcon={showIcon}/>
	} else {
		return props.children
	}
}

export function renderBannerInstall(deferredPrompt) {
	return (
		<div className='container'>
			<div className='card' style={{paddingLeft:5, paddingRight:5, paddingTop:5}}>
				<div className="card tile" style={{ color:'white'}}>
					<p style={{margin:'10px 20px 10px 20px'}}>Driver Score works best if installed on the device</p>
					<Button variant='warning' onClick={ e => deferredPrompt?.current?.prompt()} style={{marginBottom:20, width:300, color:'white', alignSelf:'center'}} >Install</Button>
				</div>
			</div>
		</div>
	)
}

export const isIos = () => {
	const userAgent = window.navigator.userAgent.toLowerCase();
	console.log('userAgent = ', userAgent)
	return /iphone|ipad|ipod/.test( userAgent );
  }

export function renderIOSBannerInstall() {

	  // Detects if device is in standalone mode
	  const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

	if (isIos() && !isInStandaloneMode()) {
		return (
			<div className='container'>
				<div className='card' style={{paddingLeft:5, paddingRight:5, paddingTop:5}}>
					<div className="card tile" style={{ color:'white'}}>
						<p style={{margin:'10px 20px 10px 20px'}}>Install Driver Score on your iOS device.  Tap the &nbsp; <i className="fa-solid fa-arrow-up-from-bracket" /> &nbsp; and select &nbsp; <i className="fa-regular fa-square-plus" /> &nbsp;Add to Home Screen</p>
						
					</div>
				</div>
			</div>
		)
	}  
	
}